import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UserEditPopupService {
private apiUrl = `${environment.baseUrlResetPass}user`;
constructor(private http: HttpClient) { }

getUserList(): Observable<any> {
  const token = sessionStorage.getItem("token");
  const headers = new HttpHeaders({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  });
  return this.http.get(`${this.apiUrl}/list`, { headers });
}

}
